var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcPause = function SvgIcPause(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_pause")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_pause",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_player_stop",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C10.5522847,0 11,0.44771525 11,1 L11,24 C11,24.5522847 10.5522847,25 10,25 L1,25 C0.44771525,25 0,24.5522847 0,24 L0,1 C0,0.44771525 0.44771525,0 1,0 L10,0 Z M8.25,2.75 L2.75,2.75 L2.75,22.25 L8.25,22.25 L8.25,2.75 Z M10,0 C10.5522847,0 11,0.44771525 11,1 L11,24 C11,24.5522847 10.5522847,25 10,25 L1,25 C0.44771525,25 0,24.5522847 0,24 L0,1 C0,0.44771525 0.44771525,0 1,0 L10,0 Z M8.25,2.75 L2.75,2.75 L2.75,22.25 L8.25,22.25 L8.25,2.75 Z",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 C24.5522847,0 25,0.44771525 25,1 L25,24 C25,24.5522847 24.5522847,25 24,25 L15,25 C14.4477153,25 14,24.5522847 14,24 L14,1 C14,0.44771525 14.4477153,0 15,0 L24,0 Z M22.25,2.75 L16.75,2.75 L16.75,22.25 L22.25,22.25 L22.25,2.75 Z M24,0 C24.5522847,0 25,0.44771525 25,1 L25,24 C25,24.5522847 24.5522847,25 24,25 L15,25 C14.4477153,25 14,24.5522847 14,24 L14,1 C14,0.44771525 14.4477153,0 15,0 L24,0 Z M22.25,2.75 L16.75,2.75 L16.75,22.25 L22.25,22.25 L22.25,2.75 Z",
    id: "Path-2-Copy"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPause, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_pause.32bfb6e8.svg";
export { ForwardRef as ReactComponent };